/// <reference types="vite/client" />

import type { ControllerModule } from './helpers'
import { modulesByControllerName } from './helpers'
import { initializeControllerLoader } from './runtime'
import { observeTextDecorations } from './text_decoration_activation'

// All the available controllers in the world
export const AVAILABLE_CONTROLLERS = modulesByControllerName(
  import.meta.glob<ControllerModule>([
    '../**/*_controller.js',
    '../../../components/**/*_controller.js',
  ])
)

export function initializeLazyLoader() {
  initializeControllerLoader((name) => AVAILABLE_CONTROLLERS[name]?.())
  observeTextDecorations(
    document.documentElement,
    (name) => name in AVAILABLE_CONTROLLERS
  )
}
